import { Placeholders } from "..";

export const mediaFileUploadEnpoint = "/api/files/media";
export const fontFileUploadEnpoint = "/api/files/fonts";
export const campaignsDashboardEndpoint = `/api/${Placeholders.companyID}/campaignsdashboard`;
